import { z } from 'zod';

const decision = z.object({
  documentId: z.string().regex(/^[A-Za-z0-9_-]{1,128}$/),
  reviewRevision: z.string().regex(/^review-[a-f0-9]{64}$/),
  action: z.enum(['APPROVE', 'REJECT']),
});
export const DocumentDecisionCommandSchema = z.discriminatedUnion('kind', [
  decision.extend({ kind: z.literal('DOCUMENT'), checkpointId: z.string().uuid().nullable().optional() }).strict(),
  decision.extend({ kind: z.literal('WORKFLOW'), traceId: z.string().regex(/^[A-Za-z0-9_-]{1,128}$/), checkpointId: z.string().uuid().nullable() }).strict(),
]);
const identity = z.object({
  tenantId: z.string().min(1).max(200),
  actorId: z.string().min(1).max(200),
  attemptKey: z.string().uuid(),
  recordedAt: z.string().datetime(),
});
export const AppliedDocumentDecisionSchema = identity.extend({
  state: z.literal('APPLIED'), command: DocumentDecisionCommandSchema,
}).strict();
export const CancelledDocumentDecisionSchema = identity.extend({ state: z.literal('CANCELLED') }).strict();
export const DocumentDecisionAttemptSchema = z.discriminatedUnion('state', [
  AppliedDocumentDecisionSchema,
  CancelledDocumentDecisionSchema,
]);
export type DocumentDecisionCommand = z.infer<typeof DocumentDecisionCommandSchema>;
export type DocumentDecisionAttempt = z.infer<typeof DocumentDecisionAttemptSchema>;
export type AppliedDocumentDecision = z.infer<typeof AppliedDocumentDecisionSchema>;
export type CancelledDocumentDecision = z.infer<typeof CancelledDocumentDecisionSchema>;
